module.exports = __webpack_public_path__ + "151cfc412ad30005f214c2c598038717.png";